// extracted by mini-css-extract-plugin
export default {"buyerProtectionModalLink":"ModalLink-module-buyerProtectionModalLink","label":"ModalLink-module-label"};